<template>
    <div class="w-full max-w-sm mx-auto">
        <h1 class="text-3xl text-gray-800 text-center font-bold mb-8">
            Sign in
        </h1>

        <div class="relative" v-if="!showTwoFactor && !show2FAModal">
            <Sso />
            <OrActionBanner action="sign in" />
            <form
                method="post"
                action="/login"
                class="hs-form-login"
                data-hs-cf-bound="true"
                @submit.prevent="loginStore.login()"
                @keyup.enter.prevent="loginStore.login()"
            >
                <div class="space-y-5 mb-6">
                    <div>
                        <UiInput
                            type="email"
                            id="email"
                            name="email"
                            label="Email Address"
                            v-model:inputValue="loginCreds.email"
                            :errors="formErrors"
                            autofocus
                        />
                    </div>
                    <div>
                        <UiInput
                            type="password"
                            id="password"
                            name="password"
                            label="Password"
                            v-model:inputValue="loginCreds.password"
                            :errors="formErrors"
                            :options="{ toggleHidden: true }"
                        />
                        <div class="text-right pt-1">
                            <a class="link text-sm" href="/forgot-password">
                                Forgot Password?
                            </a>
                        </div>
                    </div>
                </div>

                <Errors :errors="errors" class="mb-4" />

                <ActionButton
                    @clicked="loginStore.login()"
                    label="Sign in"
                    :loading="loading"
                    :useEnter="true"
                    classes="bg-slate-800 hover:bg-slate-600 text-sm px-4 py-2.5 rounded shadow transition-colors text-white font-medium w-full"
                />

                <div class="pt-6 text-center text-slate-800 text-sm pb-safe">
                    Don't yet have an account?
                    <router-link
                        class="font-medium text-orange hover:text-orange-light transition-colors"
                        to="/register"
                    >
                        Sign up
                    </router-link>
                </div>
            </form>
        </div>
        <TotpTwoFactor v-if="showTwoFactor" />
        <TwoFactor
            :show2FAModal="show2FAModal"
            @close="loginStore.close2FAModal()"
            :intended="intended"
            :user="user"
            :phone="phone"
            mode="login"
        />
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useLoginStore } from '@/store/login';
import { onMounted } from 'vue';
import UiInput from '@/components/ui/inputs/ui-input.vue';
import Sso from '@/components/auth/sso.vue';
import ActionButton from '@/components/action-button.vue';
import Errors from '@/components/errors.vue';
import TotpTwoFactor from '@/components/auth/login-steps/totp-two-factor.vue';
import TwoFactor from '@/components/auth/two-factor.vue';
import OrActionBanner from '@/components/auth/or-action-banner.vue';

const loginStore = useLoginStore();
const {
    loginCreds,
    errors,
    formErrors,
    loading,
    show2FAModal,
    showTwoFactor,
    user,
    phone,
    intended,
} = storeToRefs(loginStore);

const storeSessions = () => {
    // Get UTM parameters from URL instead of localStorage
    const urlParams = new URLSearchParams(window.location.search);
    const utm_campaign = urlParams.get('utm_campaign');
    const utm_content = urlParams.get('utm_content');
    const utm_medium = urlParams.get('utm_medium');
    const utm_source = urlParams.get('utm_source');
    const utm_term = urlParams.get('utm_term');

    loginStore.setUtmParams({
        utm_campaign,
        utm_content,
        utm_medium,
        utm_source,
        utm_term,
    });
};

onMounted(() => {
    document.getElementById('email').focus();
    storeSessions();
});
</script>
